export * as group from './group/Group.resource';
export * as user from './user/User.resource';
export * as userPool from './userPool/UserPool.resource';
